document.addEventListener("DOMContentLoaded", function () {
  var items = document.querySelectorAll(".animate-scroll");

  if (!items.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15
  });

  items.forEach(function (item) {
    observer.observe(item);
  });
});
